const firebaseConfig = {
    apiKey: "AIzaSyDriOyr9U7btzY7gtpz08BE2TBCQBMXQzk",
    authDomain: "react-auth-shohagpro.firebaseapp.com",
    projectId: "react-auth-shohagpro",
    storageBucket: "react-auth-shohagpro.appspot.com",
    messagingSenderId: "131031837011",
    appId: "1:131031837011:web:6f52a194248bdd5e49d9a6"
  };

  export default firebaseConfig;